<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { Navigation } from '../../utilities/Navigation';

    import { api, clientSettings } from '../../../stores/api';
    import { ColumnSettingsApi } from './ColumnSettingsApi';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { mainMenu } from '../../../stores/store';
    import {
        currentImport,
        ImportResponseSchema,
    } from '../../shared/ColumnSelectPro/currentImport';
    import { ImportApi } from '../Import/ImportApi';
    import IconBack from '../../shared/Icons/IconBack.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { debug } from '../../../stores/store';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import ColumnSelectManager from '../../shared/ColumnSelectPro/ColumnSelectManager.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import ButtonAddSomething from '../../shared/ButtonAddSomething.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import { openModal } from 'svelte-modals';
    import ModalError from '../../shared/Modals/ModalError.svelte';

    import mockImportShort from './mock/importShort.json';
    import { SelectManager } from '../../shared/ColumnSelectPro/SelectManager';
    import { features } from '../../shared/Features/features';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { VALIDATE } from '../../shared/ColumnSelectPro/types';
    import WarningColor from '../../shared/WarningColor.svelte';
    import InfoColor from '../../shared/InfoColor.svelte';
    import Opacity from '../../shared/Opacity.svelte';

    let allowGoNext = false;
    let reasons: string[] = [];
    let loading: boolean = true;
    let processing: boolean = false;
    let error: string = '';
    let intervalHandler: any = null;
    let isSelectedDay: boolean = false;

    let sm: SelectManager = new SelectManager();

    /* $currentImport is null before fetching data from API */
    /* $currentImport.columns_assigment is null before columns are assigned by API (default settings) */

    function onValidate(isValidated: boolean, _reasons: string[]) {
        allowGoNext = isValidated;
        reasons = _reasons;
        console.log('AssignColumns: onValidate', isValidated, reasons);
    }

    function tryToGetColumnSettingsWithTimeout() {
        function tryToGetColumnSettings() {
            console.log('AssignColumns: Fetching columns settings...');
            if ($currentImport !== null) {
                loading = true;
                ImportApi.getOne($api, $currentImport.id)
                    .then(response => {
                        console.log('AssignColumns: Columns settings fetched!', response);
                        if (response !== null && response.columns_assignment !== null) {
                            ImportResponseSchema.parse(response);
                            console.log('AssignColumns: Columns settings fetched!', response);
                            // $currentImport = {...mockImportShort}
                            $currentImport = { ...response };
                            if ($currentImport?.columns_assignment) {
                                sm = sm.set(
                                    $currentImport.columns_assignment.elements,
                                    $currentImport.columns_assignment.options,
                                    $currentImport.columns_assignment.sections
                                );
                            } else {
                                console.warn(
                                    'AssignColumns: columns_assignment are empty!',
                                    response
                                );
                            }
                            loading = false;
                        } else {
                            intervalHandler = setTimeout(tryToGetColumnSettings, 1000);
                        }
                    })
                    .catch(err => {
                        console.log('AssignColumns: Columns settings fetch error!', err);
                        loading = false;
                    });
            }
        }

        tryToGetColumnSettings();
    }

    function processColumnSettings() {
        console.log('AssignColumns: Columns settings update', $currentImport);
        if ($currentImport !== null && $currentImport.columns_assignment !== null) {
            processing = true;
            //ColumnSettingsApi.updateColumnSettings($api, $currentImport.id, $currentImport.columns_assignment).then( (response) => {
            let { target_date, history_import, ..._ } = $currentImport;
            let columns_assignment = {
                elements: sm.getElements(),
                sections: sm.getSections(),
                options: sm.getOptions(),
            };
            if (!isSelectedDay) {
                target_date = null;
            }
            ColumnSettingsApi.update($api, $currentImport.id, {
                columns_assignment,
                target_date,
                history_import,
            })
                .then(response => {
                    console.log('AssignColumns: Columns settings updated!', response);
                    if (
                        response !== null &&
                        response?.columns_assignment !== null &&
                        typeof response.id === 'number'
                    ) {
                        $currentImport = {
                            ...$currentImport,
                            columns_assignment: response.columns_assignment,
                        };
                    }
                    if ($currentImport && $currentImport.id !== null) {
                        Navigation.navigate(`/import-analyze`);
                    }
                })
                .catch(err => {
                    console.warn('AssignColumns: data', $currentImport);
                    console.warn('AssignColumns: Columns settings update error!', err);
                    openModal(ModalError, { text: err });
                    processing = false;
                });
        }
    }

    onMount(() => {
        if ($currentImport === null) {
            console.log('AssignColumns: No file uploaded, redirecting to upload-file page');
            Navigation.navigate('/upload-file');
        }
        tryToGetColumnSettingsWithTimeout();

        return () => {
            if (intervalHandler) clearInterval(intervalHandler);
        };
    });

    $: {
        if ($currentImport && $currentImport.target_date === null) {
            const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;
            $currentImport.target_date = new Date(
                Date.now() - new Date().getTimezoneOffset() * 60 * 1000 + ONE_DAY_IN_MILLISECONDS
            )
                .toISOString()
                .slice(0, 10);
        }
    }
</script>

{#if $currentImport !== null}
    <TemplateStandard>
        <div slot="header" style="width: 100%;">
            <TemplateHeaderDuo>
                <div slot="main-header">
                    <TemplateRow>
                        <IconBack
                            on:click={() => {
                                window.history.back();
                            }}
                            scale={0.7}
                        />
                        {$_('Ustawienia kolumn')}
                    </TemplateRow>
                </div>
                <div slot="main-buttons" style="display: flex; justify-items: center;">
                    <ButtonMain
                        text={$_('btn-next')}
                        on:click={processColumnSettings}
                        disabled={!allowGoNext || processing}
                    />
                </div>
            </TemplateHeaderDuo>
        </div>
        <div slot="content">
            {#if error}
                <MessageDanger {error} />
            {/if}
            {#if loading}
                <Spinner />
            {:else}
                <div style="overflow-y: auto; overflow-x: hidden; margin: 0 0; padding: 20px; ">
                    <div
                        style="display: flex; flex-direction: column; justify-content: flex-end; align-items: right; height: 20px;"
                    >
                        {#if !allowGoNext && reasons.length > 0}
                            {#if reasons.includes(VALIDATE.MISSING_XY_OR_CITY_STREET)}
                                <ErrorInline text={$_(VALIDATE.MISSING_XY_OR_CITY_STREET)} />
                            {/if}
                            {#if reasons.includes(VALIDATE.X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED)}
                                <ErrorInline
                                    text={$_(VALIDATE.X_SHOULD_BE_SELECTED_IF_Y_IS_SELECTED)}
                                />
                            {/if}
                            {#if reasons.includes(VALIDATE.Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED)}
                                <ErrorInline
                                    text={$_(VALIDATE.Y_SHOULD_BE_SELECTED_IF_X_IS_SELECTED)}
                                />
                            {/if}
                            {#if reasons.includes(VALIDATE.ERRORS_EXISTS)}
                                <ErrorInline text={$_(VALIDATE.ERRORS_EXISTS)} />
                            {/if}
                        {/if}
                    </div>
                    {#if $features?.feature_easyvrp_enable_import_history === true}
                        <div
                            style="display:flex; flex-direction:column; align-items: center; padding: 0 0 20px 0; font-size: 14px; column-gap: 10px; background-color: #f5f5dc; border-radius: 5px; padding: 10px;"
                        >
                            <TemplateRow justifyContent="flex-start">
                                <Checkbox
                                    bind:checked={$currentImport.history_import}
                                    label={$_('import_as_historical')}
                                    disabled={false}
                                />
                                <InfoColor>
                                    <ul>
                                        <li>
                                            {$_(
                                                'historical_import_info'
                                            )}
                                        </li>
                                        <li>
                                            {$_(
                                                'historical_import_vehicles_created'
                                            )}
                                        </li>
                                        <li>
                                            {$_(
                                                'historical_import_warehouse_created'
                                            )}
                                        </li>
                                        <li>
                                            {$_(
                                                'historical_import_existing_vehicles_unchanged'
                                            )}
                                        </li>
                                        <li>
                                            {$_(
                                                'historical_import_enable_layer'
                                            )}
                                        </li>
                                        <li>
                                            {$_(
                                                'historical_import_reset_removes'
                                            )}
                                        </li>
                                    </ul>
                                </InfoColor>
                                <WarningColor
                                    >{$_(
                                        'historical_import_assign_vehicle_column'
                                    )}</WarningColor
                                >
                                <Opacity opacity={0.5}>
                                    {$_(
                                        'historical_import_feature_flag_info'
                                    )}
                                </Opacity>
                            </TemplateRow>
                        </div>
                    {/if}
                    <div
                        style="display:flex; flex-direction:column; align-items: center; padding: 0 0 20px 0; font-size: 14px; column-gap: 10px;"
                    >
                        <TemplateRow justifyContent="flex-start">
                            <Checkbox
                                bind:checked={isSelectedDay}
                                label={$_('Set the default due date') + ':'}
                                disabled={false}
                            />
                            <SelectDay
                                bind:day={$currentImport.target_date}
                                autoApply={false}
                                minDay={new Date(
                                    Date.now() - new Date().getTimezoneOffset() * 60 * 1000
                                )
                                    .toISOString()
                                    .slice(0, 10)}
                                disabled={!isSelectedDay}
                                showRelativeToday={$clientSettings.display.showRelativeToday}
                            />
                        </TemplateRow>
                    </div>
                    {#if $currentImport.columns_assignment !== null}
                        {#if sm.isSet()}
                            <ColumnSelectManager bind:sm callbacks={{ onValidate }} />
                        {:else}
                            <Spinner />
                        {/if}
                    {:else}
                        <MessageDanger header={$_('This file could not be processed')} {error} />
                    {/if}
                </div>
            {/if}
        </div>
    </TemplateStandard>
{/if}
